'use strict';

app.directive('rmIntroGuide', function ($viewport, $compile) {
  var template = _.template(
    '<div class="rm-intro-guide-step-title">${title}</div>' +
    '<div class="rm-intro-guide-step-body">${body}</div>'
  );
  function isElementInViewport (el) {
    var rect = el.getBoundingClientRect();
    return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  }
  function transformSteps ($scope, steps) {
    return _.map(steps, function (step) {
      step.position = $viewport.isMobile ?  'bottom' : step.position;
      switch (step.id) {
        //HACKS for tooltip position on different devices, for particular step
        case 'skillPoints':
          if ($viewport.isTablet) {
            step.position = 'bottom';
          }
          break;
        case 'lessonLook':
          if ($viewport.isMobile) {
            step.position = 'bottom-right-aligned';
          }
          break;
        case 'lessonIntroduction':
        case 'preQuiz':
          if ($viewport.isTablet) {
            step.position = 'right';
          }
          break;
      }
      return {
        element: '#guide-' + step.id,
        position: step.position,
        tooltipClass: 'rm-intro-guide-popup',
        intro: $compile(angular.element('<div>' + template(step) + '</div>'))($scope).html()
      };
    });
  }
  var defaultOptions = {
    steps: [],
    showStepNumbers: false,
    scrollToElement: false,
    exitOnOverlayClick: true,
    exitOnEsc: true,
    nextLabel: 'NEXT >',
    prevLabel: '< BACK',
    overlayOpacity: 0.6,
    skipLabel: 'Exit',
    doneLabel: 'NEXT >'
  };
  return {
    restrict: 'A',
    templateUrl: '/app/directives/rm-intro-guide/rm-intro-guide.html',
    scope: {
      tourOptions: '=rmIntroGuide',
      onCompleted: '&onGuideCompleted',
      onExit: '&onGuideExit',
      onGuideChange: '&onGuideChange'
    },
    controller: function ($scope, $timeout) {
      _.merge($scope.tourOptions, defaultOptions);
      $scope.tourOptions.steps = transformSteps($scope, $scope.tourOptions.steps);
      $scope.autostart = $scope.tourOptions.steps.length > 0;
      $scope.onChange = function () {
        var self = this;
        $timeout(function () {
          var $popup = angular.element(document.querySelector('.introjs-tooltipReferenceLayer'));
          var $arrow = angular.element(document.querySelector('.introjs-arrow'));
          $popup.toggleClass('rm-intro-guide-last', self._introItems.length - 1 === self._currentStep);
          $popup.toggleClass('rm-intro-guide-first', !self._currentStep);
          var $button = angular.element(document.querySelector('.introjs-skipbutton'));
          var $nextButton = angular.element(document.querySelector('.introjs-nextbutton'));
          var $prevButton = angular.element(document.querySelector('.introjs-prevbutton'));
          var $parent = angular.element(document.querySelector('.introjs-tooltipbuttons'));
          var $tooltip = angular.element(document.querySelector('.introjs-tooltip'));
          $button.removeAttr('href');
          $prevButton.removeAttr('href');
          $nextButton.removeAttr('href');
          $button.detach();
          $parent.append($button);
          var ANIMATION_TIME = 350;
          $timeout(function () {
            if (!isElementInViewport($tooltip[0])) {
              $tooltip[0].scrollIntoView();
              if ($tooltip[0].getBoundingClientRect().left < 0) {
                $tooltip.css('left', 0);
              }
            }
            var headerHeight = document.querySelector('.layout-header').getBoundingClientRect().height;
            if ($popup[0].getBoundingClientRect().top < (headerHeight * 2)) {
              window.scrollBy(0, -(headerHeight * 2));
            }
            if ($arrow.hasClass('left-bottom') || $arrow.hasClass('right-bottom')) {
              $popup.css('top', (parseInt($popup.css('top'), 10) + 10) + 'px');
            }
          }, ANIMATION_TIME);
        });
      };
      /*
      $scope.ExitEvent = function (scope) {
        console.log("Exit Event called");
      };
      $scope.ChangeEvent = function (targetElement, scope) {
        console.log("Change Event called");
        console.log(targetElement);  //The target element
        console.log(this);  //The IntroJS object
      };


      $scope.BeforeChangeEvent = function (targetElement, scope) {
        console.log("Before Change Event called");
        console.log(targetElement);
      };

      $scope.AfterChangeEvent = function (targetElement, scope) {
        console.log("After Change Event called");
        console.log(targetElement);
      };*/

    }
  };
});
